module.exports = __webpack_public_path__ + "static/media/play-circle-color-icon.1bff813e.svg";